import { render, staticRenderFns } from "./popup-edit-version.vue?vue&type=template&id=36947fae&scoped=true"
import script from "./popup-edit-version.vue?vue&type=script&lang=js"
export * from "./popup-edit-version.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36947fae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36947fae')) {
      api.createRecord('36947fae', component.options)
    } else {
      api.reload('36947fae', component.options)
    }
    module.hot.accept("./popup-edit-version.vue?vue&type=template&id=36947fae&scoped=true", function () {
      api.rerender('36947fae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/common/popup-edit-version.vue"
export default component.exports